import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HamburgerGlyph = /*#__PURE__*/createElement("g", {
  id: "hamburger"
}, /*#__PURE__*/createElement("path", {
  d: "M68,27.9H16c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h52c0.8,0,1.5,0.7,1.5,1.5S68.8,27.9,68,27.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M68,43.5H16c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h52c0.8,0,1.5,0.7,1.5,1.5S68.8,43.5,68,43.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M68,59.1H16c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h52c0.8,0,1.5,0.7,1.5,1.5S68.8,59.1,68,59.1z"
}));
const Hamburger = createSvg({
  name: 'hamburger',
  path: HamburgerGlyph
});

export default Hamburger;
export { HamburgerGlyph };
